/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Askclinic2Inputs */

const en_signin_askclinic2 = /** @type {(inputs: Signin_Askclinic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please ask the reception to send you a new link via SMS.`)
};

const fr_signin_askclinic2 = /** @type {(inputs: Signin_Askclinic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez demander à la réception de vous envoyer un nouveau lien par SMS.`)
};

/**
* | output |
* | --- |
* | "Please ask the reception to send you a new link via SMS." |
*
* @param {Signin_Askclinic2Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const signin_askclinic2 = /** @type {((inputs?: Signin_Askclinic2Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Askclinic2Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signin_askclinic2(inputs)
	return fr_signin_askclinic2(inputs)
});
export { signin_askclinic2 as "signIn_askClinic" }